module.exports = __webpack_public_path__ + "img/ltkaustralia-2x.3e4dc15.jpg";